/* Kundenumfrage — Surpresa Natural, 02.09.2026
   Vier Fragen, die letzte offen. Antworten gehen an Klaviyo und landen
   als Merkmale (uf_*) am Profil. Kein Cookie, keine eigene Ablage.

   Zweisprachig: Die Sprache kommt aus Shopify (request.locale.iso_code),
   die Section reicht sie als data-sprache durch. Alles außer "de" bekommt
   die englische Fassung. Die gespeicherten Antworten bleiben deutsch,
   damit sich Segmente über beide Sprachen hinweg bauen lassen. */
(function () {
  "use strict";

  var KLAVIYO_TOKEN = "Uzz7GU";

  var seite = document.querySelector(".uf-seite");
  var SPR = (seite && seite.getAttribute("data-sprache") || "de").toLowerCase().slice(0, 2);
  var EN = SPR !== "de";

  /* Jede Antwort trägt einen festen Schlüssel (w), der gespeichert wird,
     und die Beschriftung in beiden Sprachen. */
  var FRAGEN = [
    {
      k: "uf_befinden",
      t: { de: "Wie kommst du bisher zurecht?", en: "How are you getting on so far?" },
      u: { de: "Ganz ehrlich — es hilft mir mehr als jede höfliche Antwort.",
           en: "Be honest — that helps me more than a polite answer." },
      a: [
        { w: "Gut, zufrieden",     de: "Gut, ich bin zufrieden",   en: "Good, I am happy with it" },
        { w: "Merkt noch nichts",  de: "Ich merke noch nichts",    en: "I do not notice anything yet" },
        { w: "Vergisst es",        de: "Ich vergesse es ständig",  en: "I keep forgetting to take it" },
        { w: "Etwas passt nicht",  de: "Etwas passt nicht",        en: "Something is not right" }
      ]
    },
    {
      k: "uf_kaufgrund",
      t: { de: "Warum hast du bei uns gekauft?", en: "Why did you buy from us?" },
      u: { de: "Das ist die Frage, deren Antwort mir am meisten hilft.",
           en: "This is the question whose answer helps me most." },
      a: [
        { w: "Zutaten",        de: "Die Zutaten haben mich überzeugt", en: "The ingredients convinced me" },
        { w: "Eigenherstellung", de: "Weil ihr selbst herstellt",      en: "Because you make it yourselves" },
        { w: "Preis",          de: "Preis und Menge haben gepasst",    en: "Price and quantity were right" },
        { w: "Empfehlung",     de: "Jemand hat euch empfohlen",        en: "Someone recommended you" },
        { w: "Zufall",         de: "Ehrlich gesagt: Zufall",           en: "Honestly: chance" }
      ]
    },
    {
      k: "uf_fehlt",
      t: { de: "Fehlt dir etwas in unserem Sortiment?", en: "Is anything missing from our range?" },
      u: { de: "Kai stellt selbst her — wenn genug Leute dasselbe vermissen, machen wir es.",
           en: "Kai makes everything himself — if enough people miss the same thing, we make it." },
      a: [
        { w: "Nichts",           de: "Nein, ich finde alles",                 en: "No, I find everything" },
        { w: "Bestimmtes Produkt", de: "Ja, ein bestimmtes Produkt",          en: "Yes, a particular product" },
        { w: "Größere Packung",  de: "Größere Packungen",                     en: "Larger packs" },
        { w: "Kleinere Packung", de: "Kleinere Packungen zum Ausprobieren",   en: "Smaller packs to try" }
      ]
    }
  ];

  var T = {
    zaehler:   { de: "Frage {a} von {b}",  en: "Question {a} of {b}" },
    offenT:    { de: "Was können wir besser machen?", en: "What could we do better?" },
    offenU:    { de: "Ein Satz reicht. Ich lese jede Antwort selbst — Rosemary.",
                 en: "One sentence is enough. I read every answer myself — Rosemary." },
    platz:     { de: "Schreib einfach drauflos …", en: "Just write away …" },
    mailPlatz: { de: "deine@e-mail.de", en: "your@e-mail.com" },
    senden:    { de: "Absenden", en: "Send" },
    ohne:      { de: "ohne Kommentar absenden", en: "send without a comment" },
    dankeT:    { de: "Danke, das hilft mir wirklich.", en: "Thank you, that really helps." },
    dankeP:    { de: "Jede Antwort landet bei mir und fließt in das ein, was wir als Nächstes machen. Genau dafür frage ich.",
                 en: "Every answer comes to me and feeds into what we do next. That is exactly why I ask." },
    zurueck:   { de: "Zurück in den Shop", en: "Back to the shop" }
  };

  function t(schluessel, ersatz) {
    var s = T[schluessel][EN ? "en" : "de"];
    if (ersatz) for (var k in ersatz) s = s.replace("{" + k + "}", ersatz[k]);
    return s;
  }
  function w(feld) { return feld[EN ? "en" : "de"]; }

  var SITZUNG = (function () {
    try {
      var s = sessionStorage.getItem("uf_sid");
      if (!s) {
        s = "uf_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 9);
        sessionStorage.setItem("uf_sid", s);
      }
      return s;
    } catch (e) { return "uf_" + Date.now().toString(36); }
  })();

  var p = new URLSearchParams(location.search);
  var MAIL = (p.get("email") || "").trim();
  var buehne = document.getElementById("uf-buehne");
  var schritt = 0;
  var antworten = {};
  var freitext = "";

  function esc(x) {
    return String(x).replace(/[&<>"']/g, function (z) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[z];
    });
  }

  function senden(fertig) {
    var eig = { sitzung: SITZUNG, sprache: EN ? "en" : "de", abgeschlossen: fertig ? "ja" : "nein" };
    for (var k in antworten) eig[k] = antworten[k];
    if (freitext) eig.uf_freitext = freitext;
    if (!MAIL) return Promise.resolve();
    try {
      var nutz = {
        token: KLAVIYO_TOKEN,
        event: "Umfrage: " + (fertig ? "abgeschlossen" : "Zwischenstand"),
        customer_properties: { $email: MAIL },
        properties: eig
      };
      var b64 = btoa(unescape(encodeURIComponent(JSON.stringify(nutz))));
      return fetch("https://a.klaviyo.com/api/track?data=" + encodeURIComponent(b64), {
        mode: "cors", keepalive: true
      }).catch(function () { return null; });
    } catch (e) { return Promise.resolve(); }
  }

  function fortschritt() {
    var gesamt = FRAGEN.length + 1;
    var pr = Math.round((schritt / gesamt) * 100);
    return '<div class="uf-balken"><i style="width:' + pr + '%"></i></div>' +
           '<p class="uf-zaehler">' +
           esc(t("zaehler", { a: Math.min(schritt + 1, gesamt), b: gesamt })) + "</p>";
  }

  function frage(i) {
    var f = FRAGEN[i];
    var h = fortschritt() +
      '<h2 class="uf-frage">' + esc(w(f.t)) + "</h2>" +
      '<p class="uf-unter">' + esc(w(f.u)) + "</p>" +
      '<div class="uf-wahlen">';
    f.a.forEach(function (a, j) {
      h += '<button class="uf-wahl" data-j="' + j + '">' + esc(w(a)) + "</button>";
    });
    h += "</div>";
    buehne.innerHTML = h;
    Array.prototype.forEach.call(buehne.querySelectorAll(".uf-wahl"), function (b) {
      b.onclick = function () {
        antworten[f.k] = f.a[+b.dataset.j].w;
        senden(false);
        schritt++;
        zeichnen();
      };
    });
  }

  function offen() {
    buehne.innerHTML = fortschritt() +
      '<h2 class="uf-frage">' + esc(t("offenT")) + "</h2>" +
      '<p class="uf-unter">' + esc(t("offenU")) + "</p>" +
      '<textarea id="uf-text" rows="5" placeholder="' + esc(t("platz")) + '"></textarea>' +
      (MAIL ? "" : '<input type="email" id="uf-mail" placeholder="' + esc(t("mailPlatz")) + '" autocomplete="email">') +
      '<button class="uf-knopf" id="uf-fertig">' + esc(t("senden")) + "</button>" +
      '<button class="uf-textknopf" id="uf-ohne">' + esc(t("ohne")) + "</button>";
    function ab() {
      var x = document.getElementById("uf-text");
      freitext = x ? x.value.trim().slice(0, 1200) : "";
      var m = document.getElementById("uf-mail");
      if (m && m.value.trim()) MAIL = m.value.trim();
      senden(true);
      schritt++;
      zeichnen();
    }
    document.getElementById("uf-fertig").onclick = ab;
    document.getElementById("uf-ohne").onclick = function () {
      var x = document.getElementById("uf-text");
      if (x) x.value = "";
      ab();
    };
  }

  function danke() {
    buehne.innerHTML =
      '<div class="uf-danke">' +
      '<h2 class="uf-frage">' + esc(t("dankeT")) + "</h2>" +
      "<p>" + esc(t("dankeP")) + "</p>" +
      '<p class="uf-sig">Rosemary · Surpresa Natural</p>' +
      '<a class="uf-knopf" href="/collections/all">' + esc(t("zurueck")) + "</a>" +
      "</div>";
  }

  function zeichnen() {
    window.scrollTo({ top: 0, behavior: "instant" });
    if (schritt < FRAGEN.length) return frage(schritt);
    if (schritt === FRAGEN.length) return offen();
    return danke();
  }

  if (buehne) zeichnen();
})();
